import Vue from 'vue'
import VueRouter from 'vue-router'
import Pago from '../views/Pago.vue'
import Pagos from '../views/Pagos.vue'
import Facturas from '../views/Facturas.vue'
import Factura from '../views/Factura.vue'
import Clientes from '../views/Clientes.vue'
import Cliente from '../views/Cliente.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)
const pushPrototype = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return pushPrototype.call(this, location).catch((e) => e)
}

const routes = [
  {
    path: '/',
    redirect: '/pagos'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/pagos',
    name: 'Pagos',
    component: Pagos,
    children: [
      {
        path: ':id',
        name: 'Pago',
        component: Pago
      }
    ]
  },
  {
    path: '/facturas',
    name: 'Facturas',
    component: Facturas,
    children: [
      {
        path: ':id',
        name: 'Factura',
        component: Factura
      }
    ]
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: Clientes,
    children: [
      {
        path: ':id',
        name: 'Cliente',
        component: Cliente
      }
    ]
  },
  {
    path: '/reportes',
    name: 'Reportes',
    component: () => import('../views/Reportes.vue')
  },
  {
    path: '/reportes/Comisiones',
    name: 'Comisiones',
    component: () => import('../components/reportes/Comisiones.vue')
  },
  {
    path: '/reportes/VentasDolares',
    name: 'VentasDolares',
    component: () => import('../components/reportes/VentasDolares.vue')
  },
  {
    path: '/reportes/efectividad',
    name: 'EfectividadCobranza',
    component: () => import('../components/reportes/Efectividad.vue')
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: () => import('../views/Pedidos.vue'),
    children: [
      {
        path: '/pedidos/:id',
        name: 'Detalles pedido',
        component: () => import('../views/PedidoDetalle.vue')
      }
    ]
  },
  {
    path: '/despachos',
    name: 'Despachos',
    component: () => import('../views/Despachos.vue'),
    children: [
      {
        path: '/despacho/:id',
        name: 'Despacho',
        component: () => import('../views/Despacho.vue')
      }
    ]
  },
  {
    path: '/NotaDeEntrega/:id',
    name: 'NotaDeEntrega',
    component: () => import('../components/distribucion/NotaDeEntrega.vue')
  },
  {
    path: '/OrdenDeSalida/:id',
    name: 'OrdenDeSalida',
    component: () => import('../components/distribucion/OrdenDeSalida.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    if (document.getElementById('app')) {
      document.getElementById('app').scrollIntoView()
    }
  }
})

export default router
